.plainIconButton {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:disabled {
    cursor: default;
  }

  .container {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg path {
    fill: currentColor !important;
  }
}
